import { Button, InlineLoading } from "@carbon/react";

export const View = ({
  disabled = false,
  isLoading = false,
  children,
  className = "",
  containerClassName = "flex-container align-items--center",
  ...rest
}) => {
  return (
    <Button
      disabled={disabled || isLoading}
      className={`switchapp-themed ${className}`}
      type="button"
      {...rest}
    >
      <div className={containerClassName}>
        {!isLoading ? null : (
          <div>
            <InlineLoading description="" />
          </div>
        )}
        {children}
      </div>
    </Button>
  );
};
